import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "oidc-react";

import App from "./App";

const queryClient = new QueryClient();

const oidcConfig = {
  onSignIn: () => {
    history.pushState({}, "", "/");
  },
  authority: import.meta.env.VITE_AUTH_CLIENT_AUTHORITY,
  clientId: import.meta.env.VITE_AUTH_CLIENT_ID,
  redirectUri: import.meta.env.VITE_HOST,
  scope: "openid profile email",
};

const Index = () => (
  <AuthProvider {...oidcConfig}>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </AuthProvider>
);

export default Index;
